export default function Works() {
  return (
    <section className="px-5 py-12">
      <div className="flex items-center gap-3">
        <h3 className="text-sm uppercase tracking-wide whitespace-nowrap">
          ALL WORKS
        </h3>
        <div className="h-px w-1/3 bg-[#D07728]/60" />
      </div>

      <h2 className="md:text-4xl text-2xl mb-8">
        A Body <br />
        of <span className="text-[#D07728]">Scholarship</span>
      </h2>

      {/* Wider layout */}
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 gap-4">

        {/* Book 2 */}
        <a href="https://amzn.eu/d/031slph1"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2024 · LANGHAM</h3>
          <img
            src="/images/africabearswitness.jpg"
            alt="Africa Bears Witness"
            className="h-24 mb-2 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Africa Bears <span className="text-[#D07728]">Witness</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            A bold account of Africa's witness to the Gospel and its significance for world Christianity today.
            <span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

        {/* Book 3 */}
        <a href="https://amzn.eu/d/084yzcPO"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2020 · SCM PRESS</h3>
          <img
            src="/images/multiculturalkingdom.jpg"
            alt="Multicultural kingdom"
            className="h-24 mb-4 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Multicultural <span className="text-[#D07728]">Kingdom</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            Ethnic diversity, mission, and the Church - a vision for a truly multicultural expression of the Kingdom of God.
            <span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

        {/* Book 4 */}
        <a href="https://amzn.eu/d/04WYDGKP"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2014 · ORBIS BOOKS</h3>
          <img
            src="/images/sentforth.jpg"
            alt="Sent Forth: African Missionary Work in the West"
            className="h-24 mb-4 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Sent Forth: African Missionary Work <span className="text-[#D07728]">in the West</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            The groundbreaking work exploring how African Christians are carrying the Gospel back to the West.
            <span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

        {/* Book 5 */}
        <a href="https://amzn.eu/d/0dURFy1f"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2023 · INDEPENDENTLY PUBLISHED</h3>
          <img
            src="/images/ourchildren.jpg"
            alt="Our children need roots and wings"
            className="h-24 mb-4 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Our Children Need <span className="text-[#D07728]">Roots and Wings</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            The book is a much-needed and ever-so-timely contribution to the ongoing conversation about African Christianity in the diaspora context. <span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

        {/* Book 6 */}
        <a href="https://amzn.eu/d/05mEqb5c"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2018 · INDEPENDENTLY PUBLISHED</h3>
          <img
            src="/images/washandpray.jpg"
            alt="Wash and pray"
            className="h-24 mb-4 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Wash and <span className="text-[#D07728]">Pray</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            This book delves into the heart of this response, exploring the intersections of faith, culture, history, and the pandemic that gripped the world from 2019 to 2022. <span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

        {/* Book 7 */}
        <a href="https://amzn.eu/d/0aMfI8Af"><div className="p-6 rounded-xl bg-[#Fcfbfa]">
          <h3 className="text-sm font-medium">2017 · GROVE BOOKS LIMITED</h3>
          <img
            src="/images/missionshapedchurch.jpg"
            alt="Mission shaped church in a multicultural world"
            className="h-24 mb-4 object-cover"
          />
          <h3 className="mt-2 md:text-2xl text-1xl">
            Mission-Shaped Church <span className="text-[#D07728]">in a Multicultural World</span>
          </h3>
          <p className="text-gray-600 mt-2 flex items-end gap-1 md:text-lg">
            If current migration trends persist, race is likely to be a central issue in mission this century, as Christianity in the UK becomes increasingly darker in complexion.<span className="text-[#D07728]">↗</span>
          </p>
        </div></a>

      </div>
    </section>
  );
}